import React, { useMemo } from "react"
import { Box, Button, Container, Grid, Heading, Stack, Text } from "@chakra-ui/react"

import { SectionProps, withSection } from "@app/hoc/Section"
import { useImage } from "@app/hooks/useImage"
import { useRoutes } from "@app/hooks/useRoutes"
import Link from "@app/components/Link"
import { useContent } from "@app/hooks/useContent"
import Image from "@app/components/Image/Image"

type ImageTextProps = GatsbyTypes.SanitySectionImageText & SectionProps

const ImageText = ({
  title,
  content,
  richTextContent,
  image,
  link,
  alignment,
  theme,
  innerRef,
  direction,
  handleTrackingClick,
}: ImageTextProps) => {
  const { getContent } = useContent()
  const { getResponsiveImage } = useImage()
  const { urlResolver } = useRoutes()

  const responsiveImage = getResponsiveImage(image)
  const resolvedLink = urlResolver(link)

  const parsedContent = useMemo(() => getContent({ content: richTextContent }), [getContent, richTextContent])

  return (
    <Box
      ref={innerRef}
      as="section"
      bg={theme === "Dark" ? "brand.beige.dark" : "white"}
      textAlign={alignment?.toString() || "center"}
      mt={theme === "Dark" ? [4.5, 5] : 0}
      mb={theme === "Dark" ? [4.5, 5] : 0}
    >
      <Container px={[4, 7]} pt={[4.5, 5]} pb={[4.5, 5]}>
        <Grid templateColumns={{ base: "none", md: "repeat(2, 1fr)" }} rowGap={4} columnGap={[4, 7]}>
          <Image {...responsiveImage} objectFit={"contain !important"} margin={"auto"} borderRadius={{ base: "unset", sm: "4%" }} />
          <Stack textAlign="center" justifyContent="center" alignItems="center" spacing={[2, 2.5]} gridRow={direction === "right" ? 1 : 0}>
            {title && (
              <Heading as="h2" size="h2">
                {title}
              </Heading>
            )}
            {parsedContent && <Box>{parsedContent}</Box>}
            {content && !parsedContent && (
              <Text as="p" size={`lg`}>
                {content}
              </Text>
            )}
            {link && (
              <Button variant="blue" as={Link} to={resolvedLink.url} onClick={handleTrackingClick}>
                {resolvedLink.title}
              </Button>
            )}
          </Stack>
        </Grid>
      </Container>
    </Box>
  )
}

export default React.memo(withSection(ImageText))
